import {
  IconBuildingStore,
  IconMessages,
  IconPhoneCall,
  IconPlugConnected,
} from '@tabler/icons-react';
import { lazy } from 'react';

import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';

import moduleInfo from '../module.json';

/**
 * Клиентская регистрация модуля Avito.
 *
 * Три экрана: переписка (основной инструмент менеджера), реестр объявлений
 * и настройки подключений.
 */
export async function setup(app: AppRuntime): Promise<void> {
  const avito = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  const groupAvito = avito.createNavigationGroup({
    key: 'avito',
    label: 'Avito',
    icon: IconBuildingStore,
    order: 40,
  });

  avito.useNavigation([
    {
      group: groupAvito,
      icon: IconMessages,
      label: 'Переписка',
      url: '/avito/messenger',
      component: lazy(() => import('./components/AvitoMessenger')),
    },
    {
      group: groupAvito,
      icon: IconBuildingStore,
      label: 'Объявления',
      url: '/avito/items',
      component: lazy(() => import('./components/AvitoItemsList')),
    },
    {
      group: groupAvito,
      icon: IconPhoneCall,
      label: 'Звонки',
      url: '/avito/calls',
      component: lazy(() => import('./components/AvitoCallsList')),
    },
    {
      group: groupAvito,
      icon: IconPlugConnected,
      label: 'Аккаунты',
      url: '/avito/accounts',
      component: lazy(() => import('./components/AvitoAccountsList')),
    },
  ]);
}
